import { useState, useEffect, useRef, useCallback } from 'react';
import apiClient from '../services/axiosInterceptor';

let cachedData = null;

export const resetPerformanceSummaryCache = () => {
  cachedData = null;
};

export const usePerformanceSummary = () => {
  const [data, setData] = useState(cachedData);
  const [loading, setLoading] = useState(!cachedData);
  const [error, setError] = useState(null);
  const hasFetched = useRef(false);

  const fetchData = useCallback(async (force = false) => {
    if (cachedData && !force) {
      setData(cachedData);
      setLoading(false);
      return;
    }
    try {
      setLoading(true);
      setError(null);

      const response = await apiClient.post(
        '/data_models_machine_learning/historical_analysis_metrics',
        null
      );

      cachedData = response?.data;
      setData(response?.data);
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'An unknown error occurred');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (cachedData) return;
    if (hasFetched.current) return;
    hasFetched.current = true;
    fetchData();
  }, [fetchData]);

  return { data, loading, error, refetch: () => fetchData(true) };
};